import type { ASPNetCoreSourceType } from '@app/types';

const extractErrorFromComplexString = (error: unknown) => {
  try {
    const jsonStartIndex = String(error).indexOf('{');
    const jsonEndIndex = String(error).lastIndexOf('}') + 1;
    const jsonResponseString = String(error).slice(
      jsonStartIndex,
      jsonEndIndex
    );

    const jsonResponse = JSON.parse(jsonResponseString);

    let errorMessage = '';
    if (jsonResponse.errors) {
      for (const key in jsonResponse.errors) {
        if (jsonResponse.errors.hasOwnProperty(key)) {
          const errorMessages = jsonResponse.errors[key];
          errorMessages.forEach((message: string, index: number) => {
            if (index === 0) {
              errorMessage = message;
            } else {
              errorMessage = `${errorMessage}, ${message}`;
            }
          });
        }
      }
    }
    return errorMessage;
  } catch (e) {
    return 'Произошла непредвиденная ошибка. Повторите попытку позже';
  }
};

const isErrorOfTypeASPNetCoreSourceType = (
  error: unknown
): error is ASPNetCoreSourceType => {
  if (typeof error === 'object' && error !== null) {
    const err = error as ASPNetCoreSourceType;
    return (
      'status' in err &&
      'data' in err &&
      typeof err.status === 'string' &&
      typeof err.data === 'string' &&
      err.data.includes('errors')
    );
  }
  return false;
};

const extractErrorsFromAspNetCoreFormat = (error: ASPNetCoreSourceType) => {
  const json = JSON.parse(error.data);
  let errorMessage = '';

  if (json.errors) {
    for (const key in json.errors) {
      if (json.errors.hasOwnProperty(key)) {
        const errorMessages = json.errors[key];

        errorMessage = `${errorMessage}${errorMessages.join('\n')}`;
      }
    }
  }

  return errorMessage;
};

export const handleCatchError = (error: unknown): string => {
  if (typeof error === 'string') {
    return error;
  }

  if (error && typeof error === 'object') {
    if ('message' in error) {
      if (
        typeof error.message === 'string' &&
        error.message.includes('errors')
      ) {
        return extractErrorFromComplexString(error);
      }
      return String(error.message);
    }

    if ('data' in error) {
      return String(error.data);
    }
  }

  if (isErrorOfTypeASPNetCoreSourceType(error)) {
    return extractErrorsFromAspNetCoreFormat(error);
  }

  return JSON.stringify(error);
};
